export default "__VITE_ASSET__GXcxcHHa__"